import { DispatchSearchType } from './enums/dispatchSearchType';

export class DispatchSearch
{
  constructor() {
    
  }
  userId: any = "";
  companyId: any = "";
  customerId: any = "";
  locationId: any = "";
  note: string = "";
  search: any = "";
  searchType: DispatchSearchType = DispatchSearchType.all;
  type: DispatchSearchType = DispatchSearchType.all;
  openStatusesOnly: boolean = true;
  isActive: boolean = true;
  startDate: Date = null;
  endDate: Date = null;
  skip: number = 0;
  take: number = 100;
}
